export const PRESENTATION ='PRESENTATION';
export const PRESENTATIONSEARCH ='PRESENTATIONSEARCH';
export const SCHEDULEINVESTORMEET ='SCHEDULEINVESTORMEET';
export const AUDIOVIDEO ='AUDIOVIDEO';
